import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { baseUrl } from '../shared/baseUrl';

export default function ResetPassword () {
  const { id, token } = useParams();
  const [valid, setValid] = useState(false);
  const [status, setStatus] = useState('Checking reset link…');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const endpoint = `${baseUrl}users/reset-password/${encodeURIComponent(id)}/${encodeURIComponent(token)}`;
  useEffect(() => {
    let active = true;
    fetch(endpoint).then(res => res.json()).then(data => {
      if (active) { setValid(data.success); setStatus(data.status); }
    }).catch(() => { if (active) setStatus('Unable to check reset link. Please try again.'); });
    return () => { active = false; };
  }, [endpoint]);
  async function submit (event) {
    event.preventDefault();
    setBusy(true);
    try {
      const res = await fetch(endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, 'confirm-password': confirmation })
      });
      const data = await res.json();
      setStatus(data.status);
      if (data.success) { setValid(false); setPassword(''); setConfirmation(''); }
    } catch (error) { setStatus('Unable to reset password. Please try again.'); }
    finally { setBusy(false); }
  }
  return <div className='container main'>
    <h3>Reset Password</h3><p role='status'>{status}</p>
    {valid && <form onSubmit={submit}>
      <label>New password (six letters or digits)
        <input type='password' autoComplete='new-password' required pattern='[A-Za-z0-9]{6}' value={password} onChange={e => setPassword(e.target.value)} />
      </label>
      <label>Confirm password
        <input type='password' autoComplete='new-password' required pattern='[A-Za-z0-9]{6}' value={confirmation} onChange={e => setConfirmation(e.target.value)} />
      </label>
      <button type='submit' disabled={busy}>Reset password</button>
    </form>}
    <a href='/'>Return to login</a>
  </div>;
}
